import styled from 'styled-components';
import { space, SpaceProps } from 'styled-system';

import { deviceBreakpoints } from '../../../hooks/useDeviceQuery.hook';

const RESPONSIVE = {
  FROM_TABLET: 'from-tablet',
  FROM_DESKTOP: 'from-desktop',
  MOBILE_ONLY: 'mobile-only',
  TABLET_ONLY: 'tablet-only',
  BELOW_DESKTOP: 'below-desktop',
} as const;

export type ResponsiveType = typeof RESPONSIVE[keyof typeof RESPONSIVE];

export interface ResponsiveContainerProps extends SpaceProps {
  responsive?: ResponsiveType;
}

export const ResponsiveContainer = styled.div`
  ${space}
  &.${RESPONSIVE.MOBILE_ONLY} {
    @media screen and ${deviceBreakpoints.fromTablet} {
      display: none;
    }
  }

  &.${RESPONSIVE.TABLET_ONLY} {
    @media not screen and ${deviceBreakpoints.tablet} {
      display: none;
    }
  }

  &.${RESPONSIVE.FROM_TABLET} {
    @media not screen and ${deviceBreakpoints.fromTablet} {
      display: none;
    }
  }

  &.${RESPONSIVE.FROM_DESKTOP} {
    @media not screen and ${deviceBreakpoints.fromDesktop} {
      display: none;
    }
  }

  &.${RESPONSIVE.BELOW_DESKTOP} {
    @media screen and ${deviceBreakpoints.fromDesktop} {
      display: none;
    }
  }
`;
